// eslint-disable-next-line no-restricted-imports -- RVCheckbox is the wrapper component that needs to import Checkbox from antd
import { Checkbox } from "antd";
import { clsx } from "clsx";

// eslint-disable-next-line no-restricted-imports
import type { CheckboxProps } from "antd/lib/checkbox";

import styles from "./RVCheckbox.module.scss";

export type RVCheckboxProps = CheckboxProps & {
    /** Additional CSS class name(s) */
    className?: string;
    /** Allow any standard data-* attributes */
    [key: `data-${string}`]: string | number | boolean | undefined;
};

/**
 * RVCheckbox
 *
 * A standardized checkbox component that wraps Ant Design's Checkbox with consistent styling.
 *
 * - Applies global checkbox styling from antd-overrides
 * - Supports both controlled and uncontrolled modes
 * - Handles disabled state with proper label coloring
 * - Supports indeterminate state for parent/child relationships
 *
 * @example
 * // Uncontrolled
 * <RVCheckbox>Remember me</RVCheckbox>
 *
 * @example
 * // Controlled
 * <RVCheckbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)}>
 *   Accept terms
 * </RVCheckbox>
 *
 * @param {RVCheckboxProps} props - Component props
 * @returns {JSX.Element}
 */
export function RVCheckbox({ className, ...checkboxProps }: RVCheckboxProps): JSX.Element {
    return <Checkbox className={clsx(styles.checkbox, className)} {...checkboxProps} />;
}
